import * as React from 'react'
import { useTranslation } from 'react-i18next'

type GeneralContactInputErrors = {
  generalEmail: string
  [key: string]: string
}

type UseGeneralContactFormReturnType = {
  generalContactFormProps: {
    email: string
    receiveRequestForProposals: boolean
    onEmailChange: (event: React.ChangeEvent<HTMLInputElement>) => void
    onReceiveRequestForProposalsChange: (event: React.ChangeEvent<HTMLInputElement>) => void
    onBlur: (event: React.FocusEvent<HTMLInputElement>) => void
    formErrors: GeneralContactInputErrors
  }
  generalEmail: string
  generalReceiveRequestForProposals: boolean
  initForm: (email: string, receiveRequestForProposals: boolean) => void
}

export const useGeneralContactForm = (contacts?: VendorContactsResponseType): UseGeneralContactFormReturnType => {
  const [email, setEmail] = React.useState<string>('')
  const { t } = useTranslation()
  const [receiveRequestForProposals, setReceiveRequestForProposals] = React.useState<boolean>(false)
  const [formErrors, setFormErrors] = React.useState<GeneralContactInputErrors>({
    generalEmail: ''
  })

  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(event.target.value)
  }

  const handleSetReceiveRequestForProposals = (_event: React.ChangeEvent<HTMLInputElement>) => {
    setReceiveRequestForProposals((prev) => !prev)
  }

  const handleBlurValidation = React.useCallback(
    (event: React.FocusEvent<HTMLInputElement>) => {
      const { value, name } = event.target
      const errorValue =
        value === ''
          ? t('required-field')
          : contacts?.generalContacts.some((contact) => contact.email.toLowerCase() === value.toLowerCase()) ||
            contacts?.userContacts.some((contact) => contact.email.toLowerCase() === value.toLowerCase())
          ? t('this-email-address-is-already-in-contacts')
          : ''

      setFormErrors((oldState) => ({ ...oldState, [name]: errorValue }))
    },
    [contacts, t]
  )

  const initForm = React.useCallback((email: string, receiveRequestForProposals: boolean) => {
    setEmail(email)
    setReceiveRequestForProposals(receiveRequestForProposals)
  }, [])

  return {
    generalContactFormProps: {
      email: email,
      receiveRequestForProposals: receiveRequestForProposals,
      onEmailChange: handleEmailChange,
      onReceiveRequestForProposalsChange: handleSetReceiveRequestForProposals,
      onBlur: handleBlurValidation,
      formErrors: formErrors
    },
    generalEmail: email,
    generalReceiveRequestForProposals: receiveRequestForProposals,
    initForm
  }
}
